import { s } from '@/theme/tokens';
import { Box, Text } from '@/ui/primitives';
import { Chip } from '@/ui/primitives/Chip';
import type { ChipColorKey, GridRenderCellParams, GridValidRowModel } from '@/ui/primitives';
import type { StatusTone } from '@/ui/primitives/Chip';
import type { ReactElement } from 'react';

export { RelativeTimeTooltipCell, RunLinkCell, TableTextCell } from './textCells';
export { StackedCountBar } from './StackedCountBar';
export type { CountSegment } from './StackedCountBar';

type MetricChipCellProps<TRow extends GridValidRowModel> = {
  params: GridRenderCellParams<TRow, number | null | undefined>;
  accentColor?: ChipColorKey | null;
  displayValue: string;
};

export const MetricChipCell = <TRow extends GridValidRowModel>({
  params,
  accentColor,
  displayValue,
}: MetricChipCellProps<TRow>): ReactElement => {
  const hasValue = params.value !== null && params.value !== undefined;
  const cellPaddingY = s('xs');
  if (!hasValue && displayValue === '-') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: cellPaddingY }}>
        <Text role="body" component="span" color="textSecondary">
          -
        </Text>
      </Box>
    );
  }

  const resolvedTone: StatusTone = accentColor ?? 'transparent';
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: cellPaddingY }}>
      <Chip label={displayValue} tone={resolvedTone} size="small" />
    </Box>
  );
};
